// Translations
import actions from './actions'
import components from './components'
import format from './format'
import generic from './generic'
import notices from './notices'
import notifications from './notifications'
import pages from './pages'
import status from './status'
import terminology from './terminology'
import time from './time'

// Translation: Arabic
export default Object.freeze({
	_: {
		code: 'ar',
		name: 'عربي'
	},
	actions,
	components,
	format,
	generic,
	notices,
	notifications,
	pages,
	status,
	terminology,
	time
})
